// Platform-native local persistence (localStorage). Survives navigation + refresh.
// NOTE: only NON-sensitive data is stored here (evidence records, settings, and a
// PUBLIC-ONLY signing identity descriptor). Private signing keys are held as
// non-extractable CryptoKeys in IndexedDB (see lib/signing.js) — never here.

const RECORDS_KEY = "signallink.records.v1";
const SETTINGS_KEY = "signallink.settings.v1";
const HCT3_KEY = "signallink.hct3.v1";
const IDENTITY_KEY = "signallink.identity.v1";

function read(key, fallback) {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : fallback;
  } catch {
    return fallback;
  }
}

function write(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
    return true;
  } catch {
    return false;
  }
}

export const storage = {
  loadRecords: () => {
    const recs = read(RECORDS_KEY, null);
    return Array.isArray(recs) ? recs : null;
  },
  saveRecords: (records) => write(RECORDS_KEY, records),
  loadSettings: () => {
    const s = read(SETTINGS_KEY, null);
    const defaults = { adaMode: false, thresholds: { observe: 25, warning: 50, critical: 75 } };
    if (!s || typeof s !== "object") return defaults;
    return {
      adaMode: !!s.adaMode,
      thresholds: { ...defaults.thresholds, ...(s.thresholds && typeof s.thresholds === "object" ? s.thresholds : {}) },
    };
  },
  saveSettings: (s) => write(SETTINGS_KEY, s),
  loadHct3: () => read(HCT3_KEY, null),
  saveHct3: (h) => write(HCT3_KEY, h),
  loadIdentity: () => read(IDENTITY_KEY, null),
  saveIdentity: (i) => write(IDENTITY_KEY, i),
  clearIdentity: () => {
    try {
      localStorage.removeItem(IDENTITY_KEY);
      return true;
    } catch {
      return false;
    }
  },
};
